@if (loan(); as loan) {
  <mat-card appearance="outlined" class="loan-summary-card">
    <mat-card-content>
      <div class="summary-content">
        <div class="due-info">
          <p>Due date: {{ loan.nextPaymentDueDate | date: "shortDate" : "UTC" }}</p>
          <p>Total due amount: {{ loan.nextPaymentDueAmount | currency }}</p>

          @if (loan.statusCode === LoanGeneralStatusCode.Closed) {
            <p style="font-weight: bold; color: #027a48; margin-top: 8px">
              This loan is closed and there is no outstanding balance.
            </p>
          }
        </div>

        <!-- ✅ Only show Make Payment if not Closed and not Charged-Off -->
        @if (loan.statusCode !== LoanGeneralStatusCode.Closed && loan.portfolio_code_id !== 4) {
          <button mat-flat-button class="payment-button" [routerLink]="['/loan', id(), 'payment']">Make payment</button>
        }

        @if (loan.portfolio_code_id === 4) {
          <p class="text-warning" style="margin-top: 8px">
            <strong>You cannot make payments through this portal.</strong>
          </p>
        }
      </div>

      <!-- ✅ Hide Auto-Pay section when Closed or Charged-Off -->
      @if (loan.statusCode !== LoanGeneralStatusCode.Closed && loan.portfolio_code_id !== 4) {
        <app-auto-pay-status [loanId]="id()" [refreshTick]="refreshTick()"> </app-auto-pay-status>
      }

      <p class="next-payment-info">
        You have a payment of {{ loan.nextPaymentDueAmount | currency }} that is due on
        {{ loan.nextPaymentDueDate | date: "shortDate" : "UTC" }}.
      </p>
    </mat-card-content>
  </mat-card>
}

<div class="view-details">
  <button mat-stroked-button class="view-details-button" [routerLink]="['detail']">Details and statements</button>
</div>

@if (loan(); as loan) {
  @if (loan.portfolio_code_id !== 4) {
    <app-upcoming-payments [loanId]="id()" (paymentsChanged)="onPaymentsChanged()"> </app-upcoming-payments>
  } @else {
    <br /><br />
  }
}

<app-payment-history [id]="id()"></app-payment-history>
